import { render, staticRenderFns } from "./DataComponent.vue?vue&type=template&id=5f750476&scoped=true&"
import script from "./DataComponent.vue?vue&type=script&lang=js&"
export * from "./DataComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataComponent.vue?vue&type=style&index=0&id=5f750476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f750476",
  null
  
)

export default component.exports